<template>

  <t-page>

    <StockProductDialog :product-id="modalStockProductId" :stock-place-product-inside-id="modalStockProductPlaceId"/>

    <t-page-list :title="currentPage.pageTitle" :user-auth="userAuth"
                 msg-return-title="Operação manual"
                 msg-return-gender-feminine
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">

      <template #search>

        <t-button
            v-if="relationAccessSubValidation('sub-action-in-manual') || relationAccessSubValidation('sub-action-out-manual')"
            primary text="Realizar Operação Manual"
            :to="currentPage.name + '-form-new'"/>

        <t-button outline-primary
                  :to="'stock-product-in-out'">
          <b-icon-arrow-left-right scale="0.8"></b-icon-arrow-left-right>
          Últimas Saídas/Entradas
        </t-button>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         big-search
                                         placeholder="Cód. Produto, Nome Produto"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-product v-model="form.productId"/>

          <b-row>

            <t-input-search cols="6" v-model="form.modelId" :options="modelOptions"
                            label="Modelo" select/>

            <t-input-search cols="6" v-model="form.groupProductId"
                            :options="groupProductOptions"
                            label="Grupo de produtos"
                            select/>

          </b-row>

          <b-row>

            <t-input-search cols="8" v-model="form.stockPlaceProductInsideId" :options="stockPlaceProductInsideOptions"
                            label="Local de Armazenamento" select/>

            <t-input-search cols="4" v-model="form.unitId"
                            :options="unitOptions"
                            label="Embalagem"
                            select/>

          </b-row>

        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               disable-actions-column
               link-primary-column="productCodeLabel"
               primary-key-column="">

        <template #first-column="{item}">
          <b-link @click="openExtractStock(item.productId,item.stockPlaceProductInsideId)">
            {{ item.productCodeLabel }}
          </b-link>
        </template>

        <template #item(stockPlaceProductInside)="{item}">
          <span v-if="item.stockOnlyNewProduced">{{ item.stockPlaceProductInside }}</span>
          <span v-else class="text-danger">{{ item.stockPlaceProductInside }}</span>
        </template>

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import http from "@/services/config/http-common";
import StockProductDialog from "@/views/modules/stock/StockProduct/dialog/StockProductDialog";
import pageListEmbeddableMixin from "@/mixins/page/pageListEmbeddableMixin";

export default {
  mixins: [pageDefaultMixin, pageListMixin, pageListEmbeddableMixin],
  components: {StockProductDialog},
  name: 'StockProductEmbeddable',
  data() {
    return {
      path: "stock/product",
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modalStockProductId: 0,
      modalStockProductPlaceId: 0,
      modelOptions: [],
      groupProductOptions: [],
      stockPlaceProductInsideOptions: [],
      unitOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.mountedPrepareEmbeddable()

    },
    async mountedContinued() {

      await http.list(this.path + "/selectRelationList").then((response) => {

        this.groupProductOptions = response.groupProductOptions
        this.modelOptions = response.modelOptions
        this.stockPlaceProductInsideOptions = response.stockPlaceProductInsideOptions
        this.unitOptions = response.unitOptions


      }).catch(error => this.responseError(error))

      await this.mountedContinuedEmbeddable() //Sempre no final

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openExtractStock(productId, stockPlaceProductInsideId) {
      this.modalStockProductId = productId
      this.modalStockProductPlaceId = stockPlaceProductInsideId
      this.openDialogForm("modal-stock-product")
    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
